module.exports = __webpack_public_path__ + "img/SmartCollege_einfarbig_RGB.0f9381be.svg";